import { FC } from "react";
import { Trans } from "react-i18next";
import styled from "styled-components";

import { ICustomField, IStyledAttributes } from "@ryde/shared";
import { greyMui } from "@ryde/theme";

const HtmlInfoStyled = styled.div.attrs<IStyledAttributes>({
  "data-e2e": "group-title-template",
})<{ $textColor?: string | null }>`
  display: flex;
  align-items: center;
  padding: 2px;
  p {
    font-size: 14px;
    font-weight: 400;
    color: ${props => props.$textColor || greyMui._700};
  }
`;

export const HtmlInfoTemplate: FC<ICustomField> = ({
  formLabelColor,
  formAttributes,
  e2eData = "html-info-template",
}) => {
  const { descriptionTranslationKey, cssStyles } = formAttributes || {};
  return (
    <HtmlInfoStyled $textColor={formLabelColor} data-e2e={e2eData}>
      <p style={cssStyles}>
        <Trans i18nKey={descriptionTranslationKey} />
      </p>
    </HtmlInfoStyled>
  );
};
